module.exports = __webpack_public_path__ + "img/volume_down.e25d4a04.svg";